import script from "./privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy.vue?vue&type=script&setup=true&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=e6cd4a32&lang=less"
import "./privacy.vue?vue&type=style&index=1&id=e6cd4a32&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6cd4a32"]])

export default __exports__